//域名统一管理
const BASE_URL = {
    // devUrl: 'http://test-yaokangfu-api.yaojixin.com',// 本地环境地址
    // devUrl: 'https://yaokangfu-api.yaojixin.com', // 本地环境地址
    devUrl: 'http://192.168.1.222:9202', // 本地环境地址
    // devUrl: 'http://192.168.0.202:9202', // 本地环境地址
    // devUrl: 'http://192.168.0.104:9202',// 本地环境地址
    testUrl: 'http://test-yaokangfu-api.yaojixin.com',// 测试环境地址
    productUrl: 'http://yaokangfu-api.yaojixin.com' // 生产地址
}
const SMS_URL = {
    devUrl: 'http://sms.yaojixin.com', // 本地环境地址
    // devUrl: 'http://192.168.0.36:9009', // 本地环境地址
    testUrl: 'http://test-sms.yaojixin.com', // 测试环境地址
    productUrl: 'http://sms.yaojixin.com' // 生产地址

}
let baseUrl = "";   //这里是一个默认的url，可以没有
let smsUrl = "";
switch (process.env.NODE_ENV) {
    case 'development': // dev 本地
        baseUrl = BASE_URL.devUrl;
        smsUrl = SMS_URL.devUrl;
        break
    case 'test':   // 生产测试
        baseUrl = BASE_URL.testUrl;
        smsUrl = SMS_URL.testUrl;
        break
    case 'production': // 生产
        baseUrl = BASE_URL.productUrl;
        smsUrl = SMS_URL.productUrl;
        break
}
// export default baseUrl;
module.exports = {
    baseUrl,
    smsUrl
}
